import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const GetRestaurants = createAsyncThunk(
  "getRestaurant",
  // const GetRestaurants = async (lastEvalutedkey) => {
  async (lastEvalutedkey) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}restList`, {
        lastEvalutedkey:
          lastEvalutedkey === ""
            ? { id: "0" }
            : { id: `${lastEvalutedkey.id}` },
        limit: "50",
      });
      if (res.data) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        throw new Error(error.response.data.error);
      }
      if (error.message) {
        throw new Error(error.message);
      }
    }
  }
);

export default GetRestaurants;
